export const permissions = [
  'activity.read',
  'activity.update',
  'activity.update.aliasesOnly',
  'aiAnalysis.dataset.read',
  'aiAnalysis.dataset.write',
  'aiAnalysis.evaluation.run',
  'aiAnalysis.review.read',
  'aiAnalysis.review.submit',
  'aiAnalysis.run.read',
  'aiEval.create',
  'challenge.subscribe',
  'claim.read',
  'claim.read.relatedOnly',
  'contract.applyWaivers',
  'contract.sendDocumentsEmail',
  'contract.sign',
  'contract.sign.relatedOnly',
  'contract.payFirstInstallment',
  'contract.payFirstInstallment.relatedOnly',
  'contract.assignPaymentMethod',
  'contract.assignPaymentMethod.relatedOnly',
  'contract.assignPaymentMethod.managedByOrusOnly',
  'contract.read',
  'contract.read.relatedOnly',
  'contract.read.allowedOnly',
  'contract.update',
  'contract.update.managedByOrusOnly',
  'contract.updateOrganization',
  'contract.cpms',
  'contract.requestUpdate',
  'contract.requestUpdate.relatedOnly',
  'dashboard.read',
  'endorsement.create',
  'endorsement.create.managedByOrusOnly',
  'endorsement.manage.reservedProducts',
  'endorsement.read',
  'endorsement.read.relatedOnly',
  'endorsement.read.allowedOnly',
  'endorsement.validateUserGeneratedValidationRequest',
  'earnings.write',
  'earnings.read',
  'internalTools.read',
  'invoice.configuration',
  'invoice.configuration.managedByOrusOnly',
  'invoice.create',
  'invoice.create.managedByOrusOnly',
  'invoice.pay',
  'invoice.pay.managedByOrusOnly',
  'invoice.refund',
  'invoice.markAsPaid',
  'invoice.markAsPaid.managedByOrusOnly',
  'invoice.read',
  'invoice.regenerateDocuments',
  'billingExemption.read',
  'billingExemption.create',
  'billingExemption.update',
  'billingExemption.delete',
  'invoice.syncPayments',
  'job.runEphemeral',
  'log.send',
  'management.read',
  'med.read',
  'med.send',
  'membership.read',
  'membership.edit',
  'orusMembership.edit',
  'mrpa.byPassFloodRiskExclusion',
  'note.create',
  'notificationsConfiguration.read',
  'notificationsConfiguration.write',
  'onboarding.read',
  'organization.create',
  'organization.edit',
  'organizationAdvanced.edit',
  'orusOrganization.edit',
  'organization.read',
  'organization.search',
  'organization.view',
  'paymentAccount.read',
  'paymentAccount.update',
  'paymentMethod.read',
  'paymentMethod.read.relatedOnly',
  'paymentMethod.remove',
  'paymentMethod.remove.relatedOnly',
  'paymentMethod.remove.managedByOrusOnly',
  'paymentServiceProvider.read',
  'pharaoh.read',
  'rcda.compliance',
  'rcda.updateOvercharges',
  'rcda.validateDocuments',
  'report.process',
  'role.read',
  'selfOnBoarding.create',
  'session.access',
  'session.read',
  'session.impersonate',
  'session.impersonate.managedByOrusOnly',
  'slip.create',
  'slip.read',
  // TODO: Legacy name of paymentServiceProvider.read, kept while frontends loaded before the rename still check it (rollout/24h-backward-compatibility)
  'stripe.read',
  'search',
  'search.relatedOnly',
  'search.allowedOnly',
  'subscription.allowForbiddenMonthlyPaymentExemption',
  'subscription.bypassPaymentMethodsCriteria',
  'subscription.bypassMrpMaxStartDateExemption',
  'subscription.bypassAnnualCommitment',
  'subscription.archive',
  'subscription.archive.relatedOnly',
  'subscription.ignoreExclusions',
  'subscription.bypassExclusions',
  'subscription.continue',
  'subscription.changeOwner',
  'subscription.changeOwner.relatedOnly',
  'subscription.changeDealProgressState',
  'subscription.changeDealProgressState.relatedOnly',
  'subscription.create',
  'subscription.duplicateQuoteInfo',
  'subscription.duplicateQuoteInfo.relatedOnly',
  'subscription.downloadFile',
  'subscription.downloadFile.relatedOnly',
  'subscription.read',
  'subscription.read.relatedOnly',
  'subscription.prepareAttestations',
  'subscription.readHistory',
  'subscription.resetNlAovqlKnowledgeTestAttempts',
  'subscription.sendAttestations',
  'subscription.shareLink',
  'subscription.shareLink.relatedOnly',
  'subscription.skipNlAovqlKnowledgeTest',
  'subscription.uploadFile',
  'subscription.uploadFile.relatedOnly',
  'subscription.updatePaymentDay',
  'subscription.updatePricingVersion',
  'tech.configurations',
  'tech.platformStatus.read',
  'timeline.read',
  'timeline.read.relatedOnly',
  'timeline.write',
  'timeline.write.relatedOnly',
  'tracking.read',
  'tracking.send',
  'user.read',
  'user.read.relatedOnly',
  'user.read.allowedOnly',
  'user.update',
  'contract.migrateOrganization',
  'invoice.update',
  'subscriptionApplicationStatus.write',
  'subscriptionApplicationStatus.read',
  'subscriptionApplicationStatus.cancelApproved',
  'subscriptionApplicationStatus.cancelRejected',
  'subscriptionApplicationStatus.takeOver',
  'subscriptionApplicationStatus.sendToInspector',
  'subscriptionApplicationStatus.sendToUnderwriter',
  'subscriptionApplicationStatus.approve',
  'subscriptionApplicationStatus.reject',
  'subscriptionApplicationStatus.incomplete',
  'subscriptionApplicationStatus.startApplication',
  'subscriptionApplicationStatus.startValidation',
  'subscriptionApplicationStatus.cancel',
  'subscriptionFileGroupStatus.write',
  'subscriptionFileGroupStatus.read',
  'subscriptionFileGroupStatus.editApproved',
  'subscriptionFileGroupStatus.editRejected',
  'subscriptionFileGroupStatus.approve',
  'subscriptionFileGroupStatus.reject',
  'subscriptionFileGroupStatus.incomplete',
  'subscriptionFileGroupStatus.sendToInspector',
  'subscriptionFileGroupStatus.sendToUnderwriter',
  'subscriptionCollectedFileStatus.write',
  'subscriptionCollectedFileStatus.read',
  'subscriptionCollectedFileStatus.editApproved',
  'subscriptionCollectedFileStatus.editRejected',
  'subscriptionCollectedFileStatus.approve',
  'subscriptionCollectedFileStatus.reject',
  'subscriptionCollectedFileStatus.incomplete',
  'subscriptionCollectedFileStatus.sendToInspector',
  'subscriptionCollectedFileStatus.sendToUnderwriter',
  'subscriptionUnderwriting.act',
  'systemPrompt.read',
  'systemPrompt.update',
  'debugHistory.read',
  'renewal.read',
  'renewal.validate',
  'renewal.manageForClient',
  'renewal.manageForClient.relatedOnly',
  'referral.markPayoutAsFailed',
  'referral.manage',
  'documentation.read',
  'techDocumentation.read',
  'accountManager.read',
  'excludedSubscription.manage',
  'subscription.shareWithBrokerManagerTeam',
  'reviewTasks.read',
  'reviewTasks.approve',
  'reviewTasks.reject',
  'backofficeAnnouncement.read',
  'backofficeAnnouncement.create',
  'backofficeAnnouncement.update',
  'backofficeAnnouncement.delete',
  'exclusionActivation.read',
  'exclusionActivation.update',
  'passkey.register',
  'topSalesPerformer.read',
] as const

export type Permission = (typeof permissions)[number]
export type AnyOfPermission = {
  type: 'anyOf'
  permissions: Permission[]
}

export function isPermission(value: string): value is Permission {
  return permissions.includes(value as Permission)
}

export function anyOfPermissions(...permissions: Permission[]): AnyOfPermission {
  return {
    type: 'anyOf',
    permissions,
  }
}

export function getMissingPermissions(
  userPermissions: Permission[],
  requiredPermissions: (Permission | AnyOfPermission)[],
): (Permission | AnyOfPermission)[] {
  const missingPermissions = requiredPermissions.reduce(
    (acc, permissionTarget: Permission | AnyOfPermission) => {
      if (typeof permissionTarget === 'string') {
        if (!userPermissions.includes(permissionTarget)) {
          return [...acc, permissionTarget]
        }
        return acc
      } else {
        if (!permissionTarget.permissions.some((permission) => userPermissions.includes(permission))) {
          return [...acc, permissionTarget]
        }
        return acc
      }
    },
    [] as (Permission | AnyOfPermission)[],
  )

  return missingPermissions
}

export const permissionDocumentation: Record<Permission, string> = {
  'activity.read': 'Récupérer les informations des activités',
  'activity.update': 'Mettre à jour les activités',
  'activity.update.aliasesOnly': 'Mettre à jour uniquement les alias des activités',
  'aiAnalysis.dataset.read': 'Consulter les jeux de données d’évaluation IA',
  'aiAnalysis.dataset.write': 'Créer et modifier les jeux de données d’évaluation IA',
  'aiAnalysis.evaluation.run': 'Lancer une évaluation IA sur un jeu de données',
  'aiAnalysis.review.read': 'Consulter les analyses IA à relire',
  'aiAnalysis.review.submit': 'Soumettre une relecture d’analyse IA',
  'aiAnalysis.run.read': 'Consulter les analyses IA de création de devis',
  'aiEval.create': 'Créer des évaluations IA avec Braintrust',
  'challenge.subscribe': 'S’inscrire à un challenge commercial',
  'claim.read': 'Récupérer les informations de contact en cas de sinistre',
  'claim.read.relatedOnly':
    'Récupérer les informations de contact en cas de sinistre (seulement celles liées à l‘utilisateur)',
  'contract.applyWaivers': 'Appliquer des dérogations aux contrats',
  'contract.sendDocumentsEmail': 'Envoyer des emails avec les documents du contrat',
  'contract.sign': 'Signer les contrats et enregistrer le règlement',
  'contract.sign.relatedOnly': 'Signer les contrats et enregistrer le règlement (seulement ceux liés à l‘utilisateur)',
  'contract.payFirstInstallment': 'Régler soi-même la première échéance d’un client avec sa propre carte',
  'contract.payFirstInstallment.relatedOnly':
    'Régler soi-même la première échéance d’un client avec sa propre carte (seulement ceux liés à l‘utilisateur)',
  'contract.assignPaymentMethod': 'Associer un moyen de paiement à un contrat',
  'contract.assignPaymentMethod.relatedOnly':
    'Associer un moyen de paiement à un contrat (seulement ceux liés à l‘utilisateur)',
  'contract.assignPaymentMethod.managedByOrusOnly':
    'Associer un moyen de paiement à un contrat (organisations gérées par Orus uniquement)',
  'contract.read': 'Récupérer des informations sur les contrats',
  'contract.read.relatedOnly': 'Récupérer des informations sur les contrats (seulement ceux liés à l‘utilisateur)',
  'contract.read.allowedOnly':
    'Récupérer des informations sur les contrats (seulement ceux des produits autorisés pour l‘équipe externe)',
  'contract.update': 'Suspendre, résilier ou réactiver un contrat, et clôturer un sinistre décès PREL',
  'contract.update.managedByOrusOnly':
    'Suspendre, résilier ou réactiver un contrat, et clôturer un sinistre décès PREL (organisations gérées par Orus uniquement)',
  'contract.updateOrganization': 'Modifier l’organisation d’un contrat',
  'dashboard.read': 'Récupérer les données pour le dashboard',
  'endorsement.create': 'Créer des avenants',
  'endorsement.create.managedByOrusOnly': 'Créer des avenants (organisations gérées par Orus uniquement)',
  'endorsement.manage.reservedProducts':
    'Créer, modifier et annuler des avenants sur les produits réservés (mutuelle, prévoyance)',
  'endorsement.read': 'Récupérer des informations sur les avenants',
  'endorsement.read.relatedOnly': "Récupérer des informations sur les avenants (seulement ceux liés à l'utilisateur)",
  'endorsement.read.allowedOnly':
    "Récupérer des informations sur les avenants (seulement ceux des produits autorisés pour l'équipe externe)",
  'endorsement.validateUserGeneratedValidationRequest':
    'Valider les demandes de validation d’avenants soumises par les clients',
  'earnings.write': 'Modifier les revenus (frais de dossier, frais de gestion, commissions...)',
  'earnings.read': 'Récupérer les informations sur les revenus',
  'internalTools.read': 'Voir le bouton front et hubspot',
  'invoice.configuration': 'Modifier la configuration de la facturation',
  'billingExemption.read': "Voir l'historique des exonérations de facturation d'un contrat",
  'billingExemption.create': 'Créer une exonération de facturation sur un contrat',
  'billingExemption.update': 'Modifier une exonération de facturation sur un contrat',
  'billingExemption.delete': 'Supprimer une exonération de facturation sur un contrat',
  'invoice.configuration.managedByOrusOnly':
    'Modifier la configuration de la facturation (organisations gérées par Orus uniquement)',
  'invoice.update': 'Mettre à jour les informations de facturation des contrats',
  'invoice.create': 'Créer des factures',
  'invoice.create.managedByOrusOnly': 'Créer des factures (organisations gérées par Orus uniquement)',
  'invoice.pay': 'Payer les factures',
  'invoice.pay.managedByOrusOnly': 'Payer les factures (organisations gérées par Orus uniquement)',
  'invoice.refund': 'Rembourser les factures',
  'invoice.markAsPaid': 'Marquer une facture comme manuellement payée',
  'invoice.markAsPaid.managedByOrusOnly':
    'Marquer une facture comme manuellement payée (organisations gérées par Orus uniquement)',
  'invoice.read': 'Récupérer les informations sur les factures',
  'invoice.regenerateDocuments': 'Régénérer les documents de facturation (factures et reçus)',
  'invoice.syncPayments': 'Synchroniser le statut des tentatives de paiement des factures',
  'job.runEphemeral': 'Lancer des jobs éphémères',
  'log.send': 'Envoyer des logs au serveur depuis le client',
  'management.read': "Accéder à l'onglet Gestion",
  'med.read': 'Créer des mises en demeure',
  'med.send': 'Envoyer des mises en demeure',
  'membership.read': 'Lire les membres d’une organisation',
  'membership.edit': 'Modifier les membres d’une organisation',
  'orusMembership.edit': 'Modifier les rôles des membres du staff Orus (organisation orus).',
  'mrpa.byPassFloodRiskExclusion': 'Bypass de l’exclusion de risque inondation',
  'note.create': 'Gérer les notes sur tous les objets (lecture, modification, suppression)',
  'notificationsConfiguration.read': 'Récupération de la configuration des notifications',
  'notificationsConfiguration.write': 'Modification de la configuration des notifications',
  'onboarding.read': 'Récupérer les informations sur l‘onboarding de l`organisation',
  'organization.create': "Création d'organisations",
  'organization.edit': 'Modification de la liste des organisations et des membres',
  'organizationAdvanced.edit': 'Voir les paramètres avancés des organisations',
  'orusOrganization.edit': 'Modifier les produits disponibles de l’organisation Orus.',
  'organization.read': 'Lire la liste des organisations et des membres',
  'organization.search': 'Recherche des informations sur les organisations',
  'organization.view': 'Peut voir des informations sur une organization',
  'paymentAccount.read': 'TBD',
  'paymentAccount.update': 'Peut mettre à jour les informations de paiement',
  'paymentMethod.read': 'Voir le moyen de paiement d’un contrat',
  'paymentMethod.read.relatedOnly': 'Voir le moyen de paiement d’un contrat (seulement ceux liés à l‘utilisateur)',
  'paymentMethod.remove': 'Supprimer un moyen de paiement assigné à aucun contrat',
  'paymentMethod.remove.relatedOnly':
    'Supprimer un moyen de paiement assigné à aucun contrat (seulement ceux liés à l‘utilisateur)',
  'paymentMethod.remove.managedByOrusOnly':
    'Supprimer un moyen de paiement assigné à aucun contrat (organisations gérées par Orus uniquement)',
  'paymentServiceProvider.read': 'Récupérer les identifiants client chez les prestataires de paiement',
  'pharaoh.read': 'See the pharaoh page',
  'rcda.compliance': 'RCDA compliance', // Bad name, should be third-party-data.fetch
  'rcda.updateOvercharges': 'Mettre à jour la surprime RCDA',
  'rcda.validateDocuments': 'Validation des documents d’une souscription avec RCDA', // To remove -> Not used anywhere
  'report.process': 'Lancer la génération des rapports et recevoir les rapports',
  'role.read': 'Récupérer la liste des rôles et leur définition',
  'selfOnBoarding.create': 'Créer une souscription en self-onboarding',
  'session.access':
    'Récupérer les information de sa session, et faire les actions de bases nécessaires au fonctionnement du parcours de souscription',
  'session.read': 'Récupérer les informations détaillées des sessions',
  'session.impersonate':
    'Créer une session pour un autre utilisateur, pour afficher des informations et effectuer des actions en son nom',
  'session.impersonate.managedByOrusOnly':
    'Créer une session pour un autre utilisateur, pour afficher des informations et effectuer des actions en son nom (clients gérés par Orus uniquement)',
  'slip.create': 'Générer les bordereaux des organisations',
  'slip.read': 'Récupérer les bordereaux des organisations',
  //TODO: Legacy name of paymentServiceProvider.read, kept while frontends loaded before the rename still check it (rollout/24h-backward-compatibility)
  'stripe.read': 'Récupérer des objets avec l’API Stripe',
  search: 'Utiliser la recherche des contrats, souscriptions et utilisateurs',
  'search.relatedOnly':
    'Utiliser la recherche des contrats, souscriptions et utilisateurs (seulement les résultats liés à l‘utilisateur)',
  'search.allowedOnly':
    'Utiliser la recherche des contrats, souscriptions et utilisateurs (seulement les résultats des produits autorisés)',
  'subscription.archive': 'Archiver/désarchiver une souscription',
  'subscription.archive.relatedOnly': 'Archiver/désarchiver une souscription (seulement celles liées à l‘utilisateur)',
  'subscription.allowForbiddenMonthlyPaymentExemption': 'Permettre une dérogation de paiement mensuel',
  'subscription.bypassPaymentMethodsCriteria': 'Déroger aux critères de moyen de paiement d’un produit d’assurance',
  'subscription.bypassMrpMaxStartDateExemption': 'Déroger à la date de début maximale à 2 mois des contrats MRP',
  'subscription.bypassAnnualCommitment': 'Déroger à l’engagement annuel',
  'subscription.ignoreExclusions': 'Ignorer toutes les exclusions d’un contrat',
  'subscription.bypassExclusions':
    'Bypasser les exclusions désactivables au renouvellement et lors d’un avenant, ainsi que les exclusions ignorables',
  'subscription.continue': 'Continuer une souscription en cours',
  'subscription.changeOwner': 'Changer le propriétaire d’une souscription',
  'subscription.changeOwner.relatedOnly':
    'Changer le propriétaire d’une souscription (seulement celles liés à l‘utilisateur)',
  'subscription.changeDealProgressState': 'Changer le statut de progression commerciale d’une souscription',
  'subscription.changeDealProgressState.relatedOnly':
    'Changer le statut de progression commerciale d’une souscription (seulement celles liés à l‘utilisateur)',
  'subscription.create': 'Créer des souscriptions',
  'subscription.duplicateQuoteInfo': 'Dupliquer les informations d’une souscription',
  'subscription.duplicateQuoteInfo.relatedOnly':
    'Dupliquer les informations d’une souscription (seulement celles liées à l‘utilisateur)',
  'subscription.downloadFile': 'Télécharger les fichiers liés à une souscription',
  'subscription.downloadFile.relatedOnly':
    'Télécharger les fichiers liés à une souscription (seulement celles liées à l‘utilisateur)',
  'subscription.read': 'Récupérer des informations sur les souscriptions',
  'subscription.read.relatedOnly':
    'Récupérer des informations sur les souscriptions (seulement celles liées à l‘utilisateur)',
  'subscription.prepareAttestations': 'Préparer et valider les attestations RCDA à faire signer au client',
  'subscription.readHistory': 'Récupérer l’historique détaillé des souscriptions',
  'subscription.resetNlAovqlKnowledgeTestAttempts': 'Réinitialiser les tentatives du test de connaissances NL-AOVQL',
  'subscription.sendAttestations': 'Envoyer au client les attestations RCDA validées pour signature',
  'subscription.shareLink': 'Créer des liens de partage de souscription',
  'subscription.shareLink.relatedOnly':
    'Créer des liens de partage de souscription (seulement celles liées à l‘utilisateur)',
  'subscription.skipNlAovqlKnowledgeTest': 'Dispenser du test de connaissances NL-AOVQL (vente conseillée)',
  'subscription.updatePricingVersion': 'Mettre à jour la version de tarification d’une souscription',
  'subscription.uploadFile': 'Uploader des fichiers liés à une souscription',
  'subscription.uploadFile.relatedOnly':
    'Uploader des fichiers liés à une souscription (seulement celles liées à l‘utilisateur)',
  'subscription.updatePaymentDay': 'Modifier le jour de paiement d’une souscription',
  'tech.configurations': 'Configurer les paramètres techniques de l’application',
  'tech.platformStatus.read':
    'Récupérer des informations sur l’état du platforme (avancement des migrations, backlog des consumers, etc...)',
  'timeline.read': 'Lire les événements de la timeline',
  'timeline.read.relatedOnly': 'Lire les événements de la timeline d‘une subscription dont l‘utilisateur est owner.',
  'timeline.write': 'Écrire des commentaires sur la timeline',
  'timeline.write.relatedOnly':
    'Écrire des commentaires sur la timeline (seulement pour les subscriptions liées à l‘utilisateur)',
  'tracking.read': 'Récupérer des informations de documetation du tracking',
  'tracking.send': 'Envoyer des message de tracking',
  'user.read': 'Récupérer des informations sur les utilisateurs',
  'user.read.relatedOnly': 'Récupérer des informations sur les utilisateurs (seulement celles liées à l‘utilisateur)',
  'user.read.allowedOnly':
    'Récupérer des informations sur les utilisateurs (seulement ceux avec des contrats des produits autorisés pour l‘équipe externe)',
  'user.update': 'Mettre à jour des informations sur les utilisateurs',
  'contract.migrateOrganization': 'Mettre à jour l`organisation du contrat',
  'subscriptionApplicationStatus.write': 'Faire une analyse du dossier de souscription',
  'subscriptionApplicationStatus.read': 'Récupérer des informations sur l’analyse du dossier de souscription',
  'subscriptionApplicationStatus.cancelApproved': 'Permet d’annuler la validation d’un dossier',
  'subscriptionApplicationStatus.cancelRejected': 'Permet d’annuler la rejet d’un dossier',
  'subscriptionApplicationStatus.takeOver': 'Permet de reprendre un dossier en cours d’analyse',
  'subscriptionApplicationStatus.sendToInspector': 'Permet d’envoyer un dossier à l’inspecteur des courtiers',
  'subscriptionApplicationStatus.sendToUnderwriter': 'Permet d’envoyer un dossier à l’équipe d’assurance',
  'subscriptionApplicationStatus.approve': 'Permet d’approuver un dossier',
  'subscriptionApplicationStatus.reject': 'Permet de rejeter un dossier',
  'subscriptionApplicationStatus.incomplete': 'Permet de mettre un dossier en incomplet',
  'subscriptionApplicationStatus.startApplication': 'Permet de commencer l’analyse d’un dossier',
  'subscriptionApplicationStatus.startValidation': 'Permet de commencer la validation d’un dossier',
  'subscriptionApplicationStatus.cancel': 'Permet d’annuler l’analyse en cours',
  'subscriptionFileGroupStatus.write': 'Modifier le statut d’un groupe de documents',
  'subscriptionFileGroupStatus.read': 'Lire le statut d’un groupe de documents',
  'subscriptionFileGroupStatus.editApproved': 'Modifier le statut d’un groupe de documents approuvé',
  'subscriptionFileGroupStatus.editRejected': 'Modifier le statut d’un groupe de documents rejeté',
  'subscriptionFileGroupStatus.approve': 'Approuver un groupe de documents',
  'subscriptionFileGroupStatus.reject': 'Rejeter un groupe de documents',
  'subscriptionFileGroupStatus.incomplete': 'Mettre un groupe de documents en incomplet',
  'subscriptionFileGroupStatus.sendToInspector': 'Envoyer un groupe de documents à l’inspecteur des courtiers',
  'subscriptionFileGroupStatus.sendToUnderwriter': 'Envoyer un groupe de documents à l’équipe d’assurance',
  'subscriptionCollectedFileStatus.write': 'Modifier le statut d’un fichier collecté',
  'subscriptionCollectedFileStatus.read': 'Lire le statut d’un fichier collecté',
  'subscriptionCollectedFileStatus.editApproved': 'Modifier le statut d’un fichier collecté approuvé',
  'subscriptionCollectedFileStatus.editRejected': 'Modifier le statut d’un fichier collecté rejeté',
  'subscriptionCollectedFileStatus.approve': 'Approuver un fichier collecté',
  'subscriptionCollectedFileStatus.reject': 'Rejeter un fichier collecté',
  'subscriptionCollectedFileStatus.incomplete': 'Mettre un fichier collecté en incomplet',
  'subscriptionCollectedFileStatus.sendToInspector': 'Envoyer un fichier collecté à l’inspecteur des courtiers',
  'subscriptionCollectedFileStatus.sendToUnderwriter': 'Envoyer un fichier collecté à l’équipe d’assurance',
  'subscriptionUnderwriting.act':
    'Préparer l’étude de souscription d’un dossier (corriger les pièces, demander une étude) et lire les règles de l’IA',
  'systemPrompt.read': 'Récupérer le prompt système',
  'systemPrompt.update': 'Mettre à jour le prompt système',
  'debugHistory.read': 'Récupérer l’historique de debug des différents objets',
  'renewal.read': 'Afficher les informations sur les renouvellements en cours',
  'renewal.validate': 'Valider un renouvellement depuis le BO',
  'renewal.manageForClient': 'Consulter, modifier et valider les renouvellements des clients à leur place',
  'renewal.manageForClient.relatedOnly':
    'Consulter, modifier et valider à leur place les renouvellements des clients dont on est responsable',
  'referral.markPayoutAsFailed': 'Marquer un paiement de parrainage comme échoué ou annuler ce marquage',
  'referral.manage': 'Extraire les parrainages et déclencher les paiements liés au parrainage',
  'contract.cpms': 'Accéder à la page de gestion CPMS',
  'contract.requestUpdate': "Demander une mise à jour du statut d'un contrat",
  'contract.requestUpdate.relatedOnly':
    "Demander une mise à jour du statut d'un contrat (seulement ceux liés à l'utilisateur)",
  'documentation.read': 'Lire la documentation générée automatiquement',
  'techDocumentation.read': 'Lire la documentation réservée à la TECH',
  'accountManager.read': 'Récupérer les informations sur le manager Orus du compte',
  'excludedSubscription.manage': 'Voir et gérer la liste des souscriptions exclues (leads chauds)',
  'subscription.shareWithBrokerManagerTeam': "Partager un lead exclu avec l'équipe broker depuis la page souscription",
  'reviewTasks.read': 'Lire les tâches de revue à valider par un humain',
  'reviewTasks.approve': 'Approuver et envoyer une tâche de revue',
  'reviewTasks.reject': 'Rejeter une tâche de revue',
  'backofficeAnnouncement.create': 'Créer un message d’information du back-office',
  'backofficeAnnouncement.read': 'Récupérer un message d’information du back-office',
  'backofficeAnnouncement.update': 'Mettre à jour un message d’information du back-office',
  'backofficeAnnouncement.delete': 'Supprimer un message d’information du back-office',
  'exclusionActivation.read': 'Consulter la configuration des exclusions activables depuis le back-office',
  'exclusionActivation.update': 'Activer ou désactiver une exclusion depuis le back-office',
  'passkey.register': 'Enregistrer/désactiver une passkey pour se connecter sans mot de passe',
  'topSalesPerformer.read': 'Voir le top performer sales sur la page d’accueil du back-office',
}
